import { type FC } from 'react'

import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { Rating, Skeleton } from 'base-ui'

type RecommendationProductRatingProps = {
  product?: GkAirRecommendedProductDataWeb
}

export const RecommendationProductRating: FC<
  RecommendationProductRatingProps
> = ({ product }) => {
  if (!product) {
    return (
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      <div className="flex min-h-[var(--type-scale-xl-font-size)] flex-col items-center">
        <Skeleton
          // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
          className="w-[106px]"
        />
        <Skeleton
          // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
          className="mt-2 w-[40px]"
        />
      </div>
    )
  }

  const rating = product.rating_average
    ? Math.round(Number(product.rating_average))
    : 0

  if (rating === 0) {
    return (
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      <div className="invisible min-h-[calc(var(--type-scale-xl-font-size)+var(--type-scale-l-line-height)+var(--spacing-basic-4xs))]" />
    )
  }

  return (
    <span className="flex flex-col gap-0.5">
      <span className="flex" data-qa-id="product-rating">
        <Rating
          className="text-xl"
          readOnly
          slotProps={{
            iconContainer: {
              className: '-mx-0.5',
            },
          }}
          value={rating}
        />
      </span>
      <span
        className="leading-l text-dark-primary-max"
        data-qa-id="product-rating-count"
      >{`(${Number(product.rating_count)})`}</span>
    </span>
  )
}
